import { downloadFile } from '@api/Files'
import type { GeneratedImageEntry } from './mergedHtmlExtractImagePrompts'
import {
  extractImagePromptSlotsFromMergedHtml,
  serializeMergedHtmlDocument,
  writeEncodedInteractionJson
} from './mergedHtmlExtractImagePrompts'

const LOG_PREFIX = '[applyGeneratedImagesToMergedHtml]'

export async function applyGeneratedImagesToMergedHtml(
  mergedHtml: string,
  generatedImages: GeneratedImageEntry[]
): Promise<string> {
  const { rootDocument, slots } = extractImagePromptSlotsFromMergedHtml(
    mergedHtml
  )

  if (generatedImages.length === 0 || slots.length === 0) {
    return mergedHtml
  }

  if (generatedImages.length !== slots.length) {
    console.log(`${LOG_PREFIX}: slot/image count mismatch`, {
      slotCount: slots.length,
      imageCount: generatedImages.length
    })
  }

  const pairCount = Math.min(slots.length, generatedImages.length)

  await Promise.all(
    Array.from({ length: pairCount }, async (_, i) => {
      const slot = slots[i]
      const entry = generatedImages[i]
      try {
        const {
          data: { path }
        } = await downloadFile({ url: entry.image_url })
        slot.decoded.image = path
        writeEncodedInteractionJson(slot.jsonDiv, slot.decoded)
      } catch (err) {
        console.error(`${LOG_PREFIX}: download failed`, { index: i, err })
      }
    })
  )

  return serializeMergedHtmlDocument(rootDocument)
}
